import { cn } from "@pharaday/lighthouse";
import type { ReactNode } from "react";

export type NavbarGroupProps = {
  className?: string;
  children: ReactNode;
};

const Group = ({ children, className }: NavbarGroupProps) => {
  return <div className={cn("flex items-center gap-2", className)}>{children}</div>;
};

export default Group;
